import { createContext, useContext } from 'react';

import type { HandbookDocument } from './handbookTypes';

export const HandbookContext = createContext<HandbookDocument | null>(null);

/** The handbook the API gave this reader; only rendered once it has arrived. */
export function useHandbook(): HandbookDocument {
  const handbook = useContext(HandbookContext);
  if (!handbook) throw new Error('useHandbook needs the handbook loaded');
  return handbook;
}
